import React, { useCallback, useRef, useState } from "react";
import {
  Box,
  Grid,
  Stack,
  Tooltip,
  Typography,
  useScrollTrigger,
  IconButton,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useParams, useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import "./boardStyle.scss";
import ReplayRoundedIcon from "@mui/icons-material/ReplayRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import Users from "./Users/Users";
import GlobalSearch from "../../../../components/Search";
import attachFileIcon from "../../../../styles/svg/attachment.svg";
import AttachmentBar from "../attachments";
import Archive from "./Archive";
import BoardName from "./BoardName";
import { isAdmin } from "../../../../utils/constants";
import { filterUser } from "../../../../redux/usersSlice";
import { searchCard } from "../../../../redux/SearchSlice";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import MilestoneSection from "../MilestoneSection";
import { useResponsive } from "../../../../hooks/useResponsive";
import StatusDropDown from "./statusDropdown/StatusDropDown";
import MilestoneTabs from "../MilestoneSection/MilestoneTabs";
import { TooltipName } from "../../../../utils/Enums";
import DrawerGlobalComp from "../../../../components/Drawer";
import { CustomButton } from "../../../../components/Button/Button";
import ViewToggle from "./components/ViewToggle";
import UserFilter from "./components/UserFilter";
import MobileActions from "./components/MobileActions";
import CustomMenu from "../../../../components/Menu";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import { useBoards } from "../../../../utils/reactQuery/boards";
import SidebarListItem from "../../../dashboard/components/SidebarListItem";
import EstimatedFilter from "./EstimatedFilter";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";
import worklogIcon from "../../../../styles/svg/updated_see_worklogs_icon.svg";
import feedIcon from "../../../../styles/svg/updated_feed_icon.svg";
import boardDocumentIcon from "../../../../styles/svg/board_document_icon.svg";
import { useNavigate } from "react-router-dom";
import { localStorageInstance } from "../../../../utils/localStorage";
import { setGridView } from "../../../../redux/SearchSlice";
import { useLocation } from "react-router-dom";
import BoardDocument from "./BoardDocument";

function BoradHeader({ boardName, boardId, ownerId, workflowId, setLoading }) {
  const { id } = useBoardIdByKey();
  const { id: key } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const cachedData = queryClient.getQueryData(["boardName", id]);
  const [milestone, setMilestone] = useCustomSearchParams("milestone");
  const [paramsWorklogs, setParamsWorklogs] = useCustomSearchParams("worklogs");
  const isMobile = useResponsive("down", "md");
  const [filterDrawer, setFilterDrawer] = useState(false);
  const showGridView = useSelector((state) => state.search.gridView);
  const [openSearchField, setOpenSearchField] = useState(false);
  const [selectedUserSearch, updateSearchParams, removeSearchParam] =
    useCustomSearchParams("search");
  const [changeBoardAnchorEl, setChangeBoardAnchorEl] = useState(null);
  const openChangeBoard = Boolean(changeBoardAnchorEl);
  const [showSummary, setShowSummary] = useState(false);

  const { boards } = useBoards();
  const boardList = boards?.data?.data?.responseData || [];

  const [attachmentDialog, setAttachmentDialog] = useState({
    right: false,
  });

  const selectedUsers = selectedUserSearch?.split(",");

  const handleChange = (event) => {
    const value = event?.target?.value?.trimStart();
    setInputValue(value);
    debouncedSearch(value);
  };

  const handleSearchCancel = useCallback(() => {
    setInputValue("");
    setOpenSearchField(false);
    dispatch(searchCard(""));
  }, [dispatch]);

  const debouncedSearch = useRef(
    _.debounce((value) => {
      dispatch(searchCard(value));
    }, 300)
  ).current;

  const [inputValue, setInputValue] = useState("");
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setAttachmentDialog((prev) => ({ ...prev, [anchor]: open }));
  };

  const removeSearchParams = (paramsToRemove) => {
    const newSearchParams = new URLSearchParams(searchParams);
    paramsToRemove?.forEach((param) => {
      newSearchParams.delete(param);
    });
    setSearchParams(newSearchParams);
  };

  const clearFilters = (e) => {
    e === "clear"
      ? removeSearchParams(["search"])
      : removeSearchParams(["search", "milestone"]);

    dispatch(filterUser(null));
    dispatch(searchCard([]));
  };
  const trigger = useScrollTrigger();

  const handleOpenSearchField = useCallback(() => {
    setOpenSearchField(!openSearchField);
  }, [openSearchField]);

  const handleCloseFilterDrawer = useCallback(() => {
    setFilterDrawer(false);
  }, [setFilterDrawer]);

  const handleOpenChangeBoard = useCallback(
    (event) => {
      setChangeBoardAnchorEl(event.currentTarget);
    },
    [setChangeBoardAnchorEl]
  );

  const handleCloseChangeBoard = useCallback(() => {
    setChangeBoardAnchorEl(null);
  }, [setChangeBoardAnchorEl]);

  const getFilteredParams = () => {
    const keysToExtract = ["noMilestone", "milestone", "GantChart", "search"];
    const extracted = new URLSearchParams();

    keysToExtract.forEach((key) => {
      const value = searchParams.get(key);
      if (value !== null) {
        extracted.set(key, value);
      }
    });

    return extracted.toString();
  };
  const handleWorklogsNavigate = (boardNumber) => {
    const filteredSearch = getFilteredParams();
    navigate(`/board/${key}?worklogs=true${filteredSearch ? `&${filteredSearch}` : ""}`);
    localStorageInstance.setItem({
      key: "showGridView",
      value: false,
    });
  };

  const setFeedsNavigate = (boardId) => {
    const filteredSearch = getFilteredParams();
    navigate(`/feeds/${key}?worklogs=false${filteredSearch ? `&${filteredSearch}` : ""}`);
    localStorageInstance.setItem({
      key: "showGridView",
      value: false,
    });
  };
  const isPermission = isAdmin() || cachedData?.data?.data?.responseData?.is_owner || cachedData?.data?.data?.responseData?.board_permission?.is_admin;


  return (
    <>
      {openSearchField ? (
        <Grid
          container
          item
          xs={12}
          className="remove-container-width fixed-ui"
          justifyContent={"center"}
          alignItems={"center"}
        >
          <GlobalSearch
            placeholder={"Search..."}
            searchText={inputValue}
            handleChange={handleChange}
            onCancel={handleSearchCancel}
            showCancel={true}
            fullWidth={true}
          />
        </Grid>
      ) : (
        <Grid
          container
          item
          xs={12}
          className={`remove-container-width fixed-ui ${
            isMobile ? "mobile-board-header-container" : ""
          }`}
          sx={{ top: trigger ? "0px" : isMobile ? "50px" : "" }}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid
            item
            xs={6}
            md={12}
            lg={4}
            className="d-flex align-items-center"
          >
            {boardName && <BoardName boardName={boardName} />}
            {isMobile && (
              <KeyboardArrowDownIcon
                className="mobile-change-board-btn"
                onClick={handleOpenChangeBoard}
              />
            )}
          </Grid>
          <CustomMenu
            anchorEl={changeBoardAnchorEl}
            open={openChangeBoard}
            className="mobile-change-board-menu"
            onClose={handleCloseChangeBoard}
          >
            {boardList &&
              boardList
                .filter((board) => !board?.is_archive)
                .sort((a, b) => a?.board_name?.localeCompare(b?.board_name))
                .map((board) => (
                  <CustomMenuItem key={board?.id}>
                    <SidebarListItem board={board} />
                  </CustomMenuItem>
                ))}
          </CustomMenu>

          <Grid item xs={6} md={7} lg={8}>
            <div className="d-flex justify-content-end align-items-center">
              {isMobile ? (
                <>
                  <MobileActions
                    setAttachmentDialog={setAttachmentDialog}
                    attachmentDialog={attachmentDialog}
                    setFilterDrawer={setFilterDrawer}
                    openSearchField={openSearchField}
                    handleOpenSearchField={handleOpenSearchField}
                  />
                  <Archive
                    isOwner={cachedData?.data?.data?.responseData?.is_owner}
                    isAdmin={isAdmin()}
                    boardId={boardId}
                  />
                </>
              ) : (
                <Stack spacing={1} direction="row">
                  <UserFilter
                    selectedUsers={selectedUsers}
                    clearFilters={clearFilters}
                  />

                  <Users
                    boardName={boardName}
                    boardId={boardId}
                    ownerId={ownerId}
                  />
                  {!showGridView && !location.pathname.includes("/feeds/") && paramsWorklogs === "false" && <StatusDropDown workflowId={workflowId} />}
                  <ViewToggle
                    setLoading={setLoading}
                    setParamsWorklogs={setParamsWorklogs}
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                  />

                  <Tooltip title={TooltipName.BOARD_PAGE.WORKLOGS}>
                    <IconButton
                      className="white-button attach-btn board-header-attach-btn board-header-tooltip-btn"
                      onClick={() => handleWorklogsNavigate(boardId)}
                    >
                      <img
                        src={worklogIcon}
                        className="header-filter-icon"
                        alt="not found"
                      />
                    </IconButton>
                  </Tooltip>
                  {isPermission && (

                    <>
                      <Tooltip title={TooltipName.BOARD_PAGE.FEEDS}>
                        <IconButton
                          className="white-button attach-btn board-header-attach-btn board-header-tooltip-btn"
                          onClick={() => setFeedsNavigate(boardId)}
                        >
                          <img
                            src={feedIcon}
                            className="header-filter-icon"
                            alt="not found"
                          />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}

                  <Tooltip title={TooltipName.BOARD_PAGE.BOARD_DOCUMENT}>
                    <IconButton
                      className="white-button attach-btn board-header-attach-btn board-header-tooltip-btn"
                      onClick={() => setShowSummary(true)}
                    >
                      <img
                        src={boardDocumentIcon}
                        className="header-filter-icon"
                        alt="not found"
                      />
                    </IconButton>
                  </Tooltip>



                  <Tooltip title={TooltipName.BOARD_PAGE.ADD_ATTACHMENTS}>
                    <IconButton
                      className="white-button attach-btn board-header-attach-btn board-header-tooltip-btn"
                      onClick={() =>
                        setAttachmentDialog({
                          ...attachmentDialog,
                          right: true,
                        })
                      }
                    >
                      <img
                        src={attachFileIcon}
                        className="header-filter-icon"
                        alt="not found"
                      />
                    </IconButton>
                  </Tooltip>
                  {!location.pathname.includes("feeds") && (
                  <EstimatedFilter>
                    <GlobalSearch
                      placeholder={"Search..."}
                      searchText={inputValue}
                      handleChange={handleChange}
                    />
                  </EstimatedFilter>
                )}
                  <Archive
                    isOwner={cachedData?.data?.data?.responseData?.is_owner}
                    isAdmin={isAdmin()}
                    boardId={boardId}
                  />
                </Stack>
              )}
            </div>
          </Grid>
          <MilestoneTabs
            boardName={boardName}
            isOwner={cachedData?.data?.data?.responseData?.is_owner}
          />
          {milestone && <MilestoneSection boardName={boardName} />}
        </Grid>
      )}
      {attachmentDialog && (
        <AttachmentBar state={attachmentDialog} toggleDrawer={toggleDrawer} />
      )}
      {filterDrawer && (
        <DrawerGlobalComp
          open={filterDrawer}
          setOpen={setFilterDrawer}
          className="mobile-board-filter-drawer"
        >
          <Box pt={1} pl={1} className="mobile-board-filter-drawer-header">
            <Stack direction="row" justifyContent={"space-between"}>
              <Typography fontWeight={600}>Filter By</Typography>

              <CustomButton
                size="small"
                onClick={
                  selectedUsers?.length ? clearFilters : handleCloseFilterDrawer
                }
                startIcon={
                  selectedUsers?.length ? (
                    <ReplayRoundedIcon />
                  ) : (
                    // <CloseRoundedIcon fontSize="large" />
                    ""
                  )
                }
                // disabled={!selectedUsers && !epicFilter}
                className={`capitalize mobile-reset-btn`}
              >
                {selectedUsers?.length ? "Reset" : ""}
              </CustomButton>
            </Stack>
          </Box>
          {/* <Divider /> */}
          <Box p={1} className="mobile-board-filter-drawer-users-list">
            <p className="mobile-filter-title">By Users</p>
            <Users
              boardName={boardName}
              boardId={boardId}
              ownerId={ownerId}
              setDrawerClose={() => setFilterDrawer(false)}
            // handleMobileFilterUser={handleMobileFilterUser}
            // mobileFilterSelectedUser={mobileFilterSelectedUser}
            />
          </Box>
        </DrawerGlobalComp>
      )}
      {showSummary && (
         <BoardDocument
           boardName={boardName.data.responseData.board_name}
           setShowSummary={setShowSummary}
           showSummary={showSummary}
           boardId={boardId}
           isPermission={isPermission}
         />
      )}
    </>
  );
}

export default BoradHeader;
